<template>
    <div>
        <pagamento-detalhar
            :pagamento="pagamento"
            :pagamentosServicos="pagamentosServicos"
            @obterPagamentoAtualizado="obterPagamentoAtualizado()"
        >
            <template slot="mensagem">
                <slot name="mensagem"></slot>
            </template>
            <template slot="footer" slot-scope="data">
                <app-btn-voltar></app-btn-voltar>
                <btn-certidoes
                    class="ml-2"
                    :pagamento="pagamento"
                    :servicos="pagamentosServicos"
                ></btn-certidoes>
                <pagamento-historico
                    class="ml-2"
                    :pagamento="pagamento"
                    :pagamentosServicos="pagamentosServicos"
                ></pagamento-historico>
                <btn-processar-solicitacao-autorizacao-envio-fora-do-prazo
                    :pagamento="pagamento"
                    :pagamentosServicos="pagamentosServicos"
                    @obterPagamentoAtualizado="obterPagamentoAtualizado()"
                    class="ml-2"
                >
                </btn-processar-solicitacao-autorizacao-envio-fora-do-prazo>
                <pagamento-enviar-para-analise
                    :pagamento="pagamento"
                    :pagamentosServicos="pagamentosServicos"
                    @obterPagamentoAtualizado="obterPagamentoAtualizado()"
                    class="ml-2"
                ></pagamento-enviar-para-analise>
                <btn-solicitar-autorizacao-envio-fora-do-prazo
                    :pagamento="pagamento"
                    :pagamentosServicos="pagamentosServicos"
                    @obterPagamentoAtualizado="obterPagamentoAtualizado()"
                    class="ml-2"
                >
                </btn-solicitar-autorizacao-envio-fora-do-prazo>
                <pagamento-aprovar-reprovar
                    class="ml-2"
                    :pagamento="pagamento"
                    :pagamentosServicos="pagamentosServicos"
                    @obterPagamentoAtualizado="obterPagamentoAtualizado()"
                ></pagamento-aprovar-reprovar>
                <pagamento-aprovar-com-justificativa
                    :pagamento="pagamento"
                    :pagamentosServicos="pagamentosServicos"
                    @obterPagamentoAtualizado="obterPagamentoAtualizado()"
                    class="ml-1"
                ></pagamento-aprovar-com-justificativa>
                <btn-retornar-pagamento
                    :pagamento="pagamento"
                    :pagamentosServicos="pagamentosServicos"
                    @obterPagamentoAtualizado="obterPagamentoAtualizado()"
                    class="ml-1"
                ></btn-retornar-pagamento>
                <btn-prioritario
                    class="ml-2"
                    :pagamento="pagamento"
                    :pagamentosServicos="pagamentosServicos"
                    @obterPagamentoAtualizado="obterPagamentoAtualizado()"
                ></btn-prioritario>
                <btn-especial
                    class="ml-2"
                    :pagamento="pagamento"
                    :pagamentosServicos="pagamentosServicos"
                    @obterPagamentoAtualizado="obterPagamentoAtualizado()"
                ></btn-especial>
                <b-button
                    variant="primary"
                    class="ml-2"
                    @click.stop="mostrarAnexos = true"
                    v-if="$temAcessoView('CONT-PAG-11') && !mostrarAnexos"
                    ><i class="fa fa-paperclip"></i> Documentos</b-button
                >
                <btn-exportar
                    class="ml-2"
                    :pagamento="pagamento"
                    :pagamentosServicos="pagamentosServicos"
                ></btn-exportar>
                <slot name="finalizacaoFooter" v-bind="data"></slot>
            </template>
        </pagamento-detalhar>
        <pagamento-anexos2
            v-if="$temAcessoView('CONT-PAG-11') && mostrarAnexos"
            :pagamento="pagamento"
            :pagamentosServicos="pagamentosServicos"
            @fechar="mostrarAnexos = false"
        ></pagamento-anexos2>
        <pagamento-comprometimentos
            :comprometimentos="pagamento.comprometimentos"
            :pagamentosServicos="pagamentosServicos"
            :incluirSelecao="false"
        >
            <template slot="botoes">
                <slot name="comprometimentosBotoes"></slot>
            </template>
            <template slot="comprometimentoAcoes" slot-scope="data">
                <slot name="comprometimentoAcoes"></slot>
                <pagamento-desassociar-comprometimento
                    :pagamento="pagamento"
                    :pagamentoComprometimento="data"
                    :pagamentosServicos="pagamentosServicos"
                    @obterPagamentoAtualizado="obterPagamentoAtualizado()"
                    class="mr-1"
                    v-if="mostrarBtnDesassociarComprometimento"
                ></pagamento-desassociar-comprometimento>
            </template>
        </pagamento-comprometimentos>
        <pagamento-anexos
            :pagamento="pagamento"
            :pagamentosServicos="pagamentosServicos"
            @obterPagamentoAtualizado="obterPagamentoAtualizado()"
        ></pagamento-anexos>
        <b-card no-body>
            <b-card-body>
                <app-btn-voltar></app-btn-voltar>
                <pagamento-enviar-para-analise
                    :pagamento="pagamento"
                    :pagamentosServicos="pagamentosServicos"
                    @obterPagamentoAtualizado="obterPagamentoAtualizado()"
                    class="ml-2"
                ></pagamento-enviar-para-analise>
                <btn-solicitar-autorizacao-envio-fora-do-prazo
                    :pagamento="pagamento"
                    :pagamentosServicos="pagamentosServicos"
                    @obterPagamentoAtualizado="obterPagamentoAtualizado()"
                    class="ml-2"
                >
                </btn-solicitar-autorizacao-envio-fora-do-prazo>
                <pagamento-aprovar-reprovar
                    :pagamento="pagamento"
                    :pagamentosServicos="pagamentosServicos"
                    @obterPagamentoAtualizado="obterPagamentoAtualizado()"
                ></pagamento-aprovar-reprovar>
                <btn-prioritario
                    :pagamento="pagamento"
                    :pagamentosServicos="pagamentosServicos"
                    @obterPagamentoAtualizado="obterPagamentoAtualizado()"
                ></btn-prioritario>
                <btn-especial
                    :pagamento="pagamento"
                    :pagamentosServicos="pagamentosServicos"
                    @obterPagamentoAtualizado="obterPagamentoAtualizado()"
                ></btn-especial>
                <btn-exportar
                    :pagamento="pagamento"
                    :pagamentosServicos="pagamentosServicos"
                ></btn-exportar>
            </b-card-body>
        </b-card>
    </div>
</template>

<script>
import PagamentoDetalhar from './PagamentoDetalhar'
import PagamentoComprometimentos from './PagamentoComprometimentos'
import PagamentoAnexos from './PagamentoAnexos'
import PagamentoAnexos2 from './PagamentoAnexos2'
import { pagamentoStatus } from './PagamentoStatus'
import PagamentoDesassociarComprometimento from './PagamentoDesassociarComprometimento'
import PagamentoEnviarParaAnalise from './PagamentoEnviarParaAnalise'
import PagamentoAprovarReprovar from './PagamentoAprovarReprovar'
import BtnSolicitarAutorizacaoEnvioForaDoPrazo from './BtnSolicitarAutorizacaoEnvioForaDoPrazo'
import BtnProcessarSolicitacaoAutorizacaoEnvioForaDoPrazo from './BtnProcessarSolicitacaoAutorizacaoEnvioForaDoPrazo'
import PagamentoHistorico from './PagamentoHistorico'
import BtnCertidoes from './BtnCertidoes'
import BtnPrioritario from './BtnPrioritario'
import BtnEspecial from './BtnEspecial'
import BtnExportar from './BtnExportar'
import BtnRetornarPagamento from './BtnRetornarPagamento'
import PagamentoAprovarComJustificativa from './PagamentoAprovarComJustificativa.vue'

export default {
    props: {
        pagamento: {
            type: Object,
            default: () => ({})
        },

        pagamentosServicos: {
            type: Object,
            required: true
        }
    },

    data() {
        return {
            mostrarAnexos: false
        }
    },

    methods: {
        obterPagamentoAtualizado() {
            this.$emit('obterPagamentoAtualizado')
        }
    },

    computed: {
        mostrarBtnDesassociarComprometimento() {
            return (
                (this.pagamento.status === pagamentoStatus.CRIADO ||
                    this.pagamento.status === pagamentoStatus.REPROVADO) &&
                this.$temAcesso('CONT-PAG-04')
            )
        }
    },

    components: {
        PagamentoDetalhar,
        PagamentoComprometimentos,
        PagamentoAnexos,
        PagamentoAnexos2,
        PagamentoDesassociarComprometimento,
        PagamentoEnviarParaAnalise,
        PagamentoAprovarReprovar,
        BtnSolicitarAutorizacaoEnvioForaDoPrazo,
        BtnProcessarSolicitacaoAutorizacaoEnvioForaDoPrazo,
        PagamentoHistorico,
        BtnCertidoes,
        BtnPrioritario,
        BtnEspecial,
        BtnExportar,
        BtnRetornarPagamento,
        PagamentoAprovarComJustificativa
    }
}
</script>
